import React from "react"
import { Link } from "react-router-dom"
import { RayBackground } from "@/components/RayBackground"
import { Sprout, Globe, ExternalLink, Share2 } from "lucide-react"

const LINK_COLS = [
  {
    title: "Registry",
    links: [
      { label: "Register Farmer",   href: "/register" },
      { label: "Dashboard",         href: "/dashboard" },
      { label: "GPS Map",           href: "/map" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "User Guide",        href: "/guide" },
      { label: "API Documentation", href: "/api-docs" },
      { label: "Data Export",       href: "/export" },
    ],
  },
  {
    title: "System",
    links: [
      { label: "About",             href: "/about" },
      { label: "Privacy Policy",    href: "/privacy" },
      { label: "Terms of Use",      href: "/terms" },
    ],
  },
]

const SOCIAL = [
  { Icon: Globe,       href: "#" },
  { Icon: ExternalLink, href: "#" },
  { Icon: Share2,      href: "#" },
]

export const Footer: React.FC = () => {
  return (
    <footer className="font-sans bg-white border-t border-neutral-200 mt-12">

      {/* Main Footer */}
      <div className="relative overflow-hidden border-t border-neutral-100">
        <RayBackground />

        <div className="relative z-10 max-w-[1200px] mx-auto px-6 pt-10 pb-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">

            {/* Brand Column */}
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 rounded-xl bg-green-600 flex items-center justify-center">
                  <Sprout className="w-5 h-5 text-white" />
                </div>
                <span className="font-bold text-green-700 text-base">FTR System</span>
              </Link>
              <p className="text-sm text-neutral-500 leading-relaxed">
                A digital platform for registering farmers, tracking tree inventory,
                and mapping farm locations across regions.
              </p>
            </div>

            {/* Link Columns */}
            {LINK_COLS.map(({ title, links }) => (
              <div key={title}>
                <h3 className="text-xs font-bold uppercase tracking-widest text-neutral-900 mb-4">
                  {title}
                </h3>
                <ul className="space-y-3">
                  {links.map((link) => (
                    <li key={link.href}>
                      <Link
                        to={link.href}
                        className="text-sm text-neutral-500 hover:text-green-700 transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="relative z-10 border-t border-neutral-200">
          <div className="max-w-[1200px] mx-auto px-6 py-5 flex items-center justify-between flex-wrap gap-3">
            <div className="flex items-center gap-4 flex-wrap">
              <span className="text-xs font-bold tracking-widest uppercase bg-green-700 text-white px-2.5 py-1 rounded-md">
                FTR
              </span>
              <span className="text-xs text-neutral-400">
                © {new Date().getFullYear()} Farmer Tree Registry System
              </span>
              <span className="text-neutral-300 text-xs">·</span>
              {["Privacy", "Terms"].map((label, i, arr) => (
                <React.Fragment key={label}>
                  <Link
                    to={`/${label.toLowerCase()}`}
                    className="text-xs text-neutral-400 font-medium hover:text-green-600 hover:underline transition-colors"
                  >
                    {label}
                  </Link>
                  {i < arr.length - 1 && <span className="text-neutral-300 text-xs">·</span>}
                </React.Fragment>
              ))}
            </div>

            <div className="flex items-center gap-2">
              {SOCIAL.map(({ Icon, href }, i) => (
                <a
                  key={i}
                  href={href}
                  className="w-8 h-8 flex items-center justify-center rounded-lg border border-neutral-200 text-neutral-500 hover:bg-green-700 hover:border-green-700 hover:text-white transition-all"
                >
                  <Icon size={14} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer